import isEmpty from 'lodash/isEmpty';
import { APP_IMG } from 'src/constants';
import styled from 'styled-components';
import WidgetCard from './widget-card';
import { generateDataFromDataset } from 'src/utils/datasets';

function SectionThree({ _data }: any) {
  if (isEmpty(_data?.dataSet)) return null;
  return (
    <SectionWrapper className='section-three' background={`${APP_IMG}/images/hangover/section-background-desktop.png`}>
      <div className='container'>
        <div className='title-text'>SPEAKERS</div>
        <div className='content'>
          {generateDataFromDataset(_data?.dataSet)?.map((item: any, index: number) => (
            <WidgetCard data={item} key={index} />
          ))}
        </div>
      </div>
    </SectionWrapper>
  );
}
interface StyledProps {
  background: string;
}
const SectionWrapper = styled.div<StyledProps>`
  position: relative;
  width: 100%;
  margin: auto;
  height: auto;
  padding: 120px 0;
  background-position: left bottom;
  background-image: url(${props => props?.background});
  @media (max-width: 767px) {
    padding: 80px 0;
  }
  .title-text {
    position: relative;
    font-size: 56px;
    font-weight: bolder;
    text-align: center;
    margin-bottom: 30px;
    @media (max-width: 767px) {
      font-size: 38px;
    }
  }
  .content {
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 20px 0;
    @media (max-width: 992px) {
      padding: 0 15px;
    }
    .widget-card {
      width: 22%;
      @media (max-width: 767px) {
        width: 45%;
      }
    }
  }
`;
export default SectionThree;
